module.exports = __webpack_public_path__ + "static/img/10areaB_10.4f413a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/10areaB_10.png
// module id = 1089
// module chunks = 1